import { BRAND_PROFILES, STORE_MANAGER_LIST, DEFAULT_GM_STORE } from 'constants/index';
import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  selectedStore: {
    [BRAND_PROFILES.NM]: {
      storeId: DEFAULT_GM_STORE.NM.storeId,
      storeName: DEFAULT_GM_STORE.NM.storeName,
    },
    [BRAND_PROFILES.BG]: {
      storeId: DEFAULT_GM_STORE.BG.storeId,
      storeName: DEFAULT_GM_STORE.BG.storeName,
    },
    useDefault: true,
  },
};

const updateDefaultStore = (state, payload) => {
  const defaultStoreId = payload['custom:facilityID'];
  if (!defaultStoreId || !STORE_MANAGER_LIST[defaultStoreId] || !state.selectedStore.useDefault) {
    return state.selectedStore;
  }
  const { brand, storeId, storeName } = STORE_MANAGER_LIST[defaultStoreId];
  return {
    ...state.selectedStore,
    [brand]: {
      storeId,
      storeName,
    },
  };
};

const generalManagerStores = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.SELECT_STORE:
      return {
        selectedStore: {
          ...state.selectedStore,
          [payload.brand]: {
            storeId: payload.storeId,
            storeName: payload.storeName,
          },
          useDefault: false,
        },
      };
    case '@AUTH_SET_USER':
      return {
        selectedStore: {
          ...updateDefaultStore(state, payload),
        },
      };
    case actionTypes.RESET_STORE:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default generalManagerStores;
